import { render } from "./ServiceJobComponentGroupsView.vue?vue&type=template&id=38f3be44&ts=true"
import script from "./ServiceJobComponentGroupsView.vue?vue&type=script&lang=ts"
export * from "./ServiceJobComponentGroupsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__